import React, { useState } from 'react';
import { Card } from '../components/ui/card';
import { MapPin, Phone, Clock, Navigation } from 'lucide-react';
import { branches } from '../mockData';

export const Branches = () => {
  const [selectedBranch, setSelectedBranch] = useState(branches[0]);

  return (
    <div className="min-h-screen pt-32 pb-20 px-4">
      {/* Hero Section */}
      <section className="container mx-auto mb-20 text-center">
        <div className="max-w-4xl mx-auto space-y-6">
          <h1 className="text-5xl md:text-6xl font-bold leading-tight">
            <span className="text-slate-900">Nuestras</span>
            <br />
            <span className="bg-gradient-to-r from-amber-500 to-emerald-500 bg-clip-text text-transparent">
              Sucursales
            </span>
          </h1>
          <p className="text-xl text-slate-600 leading-relaxed">
            Estamos cerca de ti en 6 estados de la República Mexicana
          </p>
        </div>
      </section>

      {/* Map with Net */}
      <section className="container mx-auto mb-12">
        <Card className="p-8 bg-gradient-to-br from-amber-50 to-emerald-50 border-2 border-amber-100">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_f35f5b38-6d8d-497e-9765-fd0e7def8902/artifacts/hh17c75d_ChatGPT%20Image%2015%20ene%202026%2C%2009_16_06%20p.m..png" 
              alt="Net" 
              className="w-32 h-32"
            />
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3">
                ¡Net te espera en cualquiera de nuestras sucursales!
              </h2>
              <p className="text-lg text-slate-600">
                Visítanos y descubre lo fácil que es obtener tu crédito. Nuestro equipo está listo para ayudarte.
              </p>
            </div>
          </div>
        </Card>
      </section>

      {/* Branches Grid */}
      <section className="container mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {branches.map((branch) => (
            <Card 
              key={branch.id}
              className={`p-6 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer border-2 ${
                selectedBranch.id === branch.id 
                  ? 'border-amber-400 bg-gradient-to-br from-amber-50 to-emerald-50' 
                  : 'border-transparent hover:border-amber-200'
              }`}
              onClick={() => setSelectedBranch(branch)}
            >
              <div className="space-y-4">
                {/* Branch Name */}
                <div className="flex items-start justify-between">
                  <div>
                    <div className="w-12 h-12 bg-gradient-to-br from-amber-400 to-emerald-400 rounded-xl flex items-center justify-center mb-3">
                      <MapPin className="text-white" size={24} />
                    </div>
                    <h3 className="text-2xl font-bold text-slate-900">{branch.name}</h3>
                  </div>
                  {selectedBranch.id === branch.id && (
                    <div className="w-8 h-8 bg-gradient-to-br from-amber-400 to-emerald-400 rounded-full flex items-center justify-center">
                      <Navigation className="text-white" size={16} />
                    </div>
                  )}
                </div>

                {/* Estado (nombre de la sucursal) */}
                <div className="flex items-start gap-3">
                  <MapPin className="text-slate-400 flex-shrink-0 mt-1" size={18} />
                  <p className="text-slate-600">{branch.name}</p>
                </div>

                {/* Hours */}
                <div className="flex items-start gap-3">
                  <Clock className="text-slate-400 flex-shrink-0 mt-1" size={18} />
                  <div className="text-sm text-slate-600 whitespace-pre-line">
                    {branch.hours}
                  </div>
                </div>

                {/* CTA */}
                <a 
                  href={`https://wa.me/5213329698523?text=Hola,%20quiero%20información%20sobre%20la%20sucursal%20de%20${branch.name}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <button className="w-full mt-4 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-semibold py-3 rounded-lg transition-all shadow-md hover:shadow-lg">
                    Contactar Sucursal
                  </button>
                </a>
              </div>
            </Card>
          ))}
        </div>
      </section>

      {/* Contact Info */}
      <section className="container mx-auto mt-20">
        <Card className="p-8 md:p-12 bg-slate-900 text-white">
          <div className="max-w-3xl mx-auto text-center space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold">
              ¿No puedes visitarnos?
            </h2>
            <p className="text-lg text-slate-300">
              No hay problema. Contáctanos por teléfono o WhatsApp y te ayudaremos con tu solicitud.
            </p>
            <div className="flex flex-wrap justify-center gap-4 pt-4">
              <a href="tel:3329698523">
                <button className="bg-white text-slate-900 font-semibold px-8 py-3 rounded-lg hover:bg-slate-100 transition-all flex items-center gap-2">
                  <Phone size={20} />
                  Llamar Ahora
                </button>
              </a>
              <a href="https://wa.me/5213329698523?text=Hola,%20necesito%20información" target="_blank" rel="noopener noreferrer">
                <button className="bg-gradient-to-r from-amber-500 to-emerald-500 hover:from-amber-600 hover:to-emerald-600 text-white font-semibold px-8 py-3 rounded-lg transition-all">
                  WhatsApp
                </button>
              </a>
            </div>
          </div>
        </Card>
      </section>
    </div>
  );
};

export default Branches;
